import React from 'react';
import { useRouteMatch, useLocation, matchPath, Switch, Route, Redirect, useHistory } from 'react-router';
import Templates from './Templates';
import ShipmentGroups from './ShipmentGroups';
import TabMenu from '@cimpress/react-components/lib/TabMenu';
import IconCommonFileStack from '@cimpress-technology/react-streamline-icons/lib/IconCommonFileStack';
import IconShipmentPackages from '@cimpress-technology/react-streamline-icons/lib/IconShipmentPackages';

// tslint:disable-next-line:import-name
import style from './index.module.css';
import { useFeature } from '../../store/hooks/useFeature';
import { Features } from '../../models/features';
import { FeatureRoute } from '../../components/utils/FeatureRoute';

export default function () {
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();

  const customShipmentGroups = useFeature(Features.CUSTOM_SHIPMENT_GROUPS);

  const tabs = [
    {
      id: 'templates',
      title: 'Templates',
      icon: IconCommonFileStack,
    },
  ];
  if (customShipmentGroups) {
    tabs.push({
      id: 'shipment-groups',
      title: 'Shipment groups',
      icon: IconShipmentPackages,
    });
  }

  const pageMatch = matchPath<{ page: string; }>(location.pathname, '/settings/:page');
  const page = pageMatch ? pageMatch.params.page : undefined;

  return <>
    <div className={style.Settings}>
      <div>
        <TabMenu
          activeTabId={page}
          tabs={tabs}
          onTabClick={(_, id) => history.push(`${match.path}/${id}`)}
        />
      </div>
      <div className={style.Section}>
        <Switch>
          <Route exact path={`${match.path}/`}><Redirect to={`${match.path}/templates`} /></Route>
          <Route path={`${match.path}/templates`} component={Templates} />
          <FeatureRoute
            whenFlag={Features.CUSTOM_SHIPMENT_GROUPS}
            path={`${match.path}/shipment-groups`}
            component={ShipmentGroups}
          />
        </Switch>
      </div>
    </div>
  </>;
}
